import { render, staticRenderFns } from "./account_page.vue?vue&type=template&id=78c25f0a&scoped=true"
import script from "./account_page.vue?vue&type=script&lang=js"
export * from "./account_page.vue?vue&type=script&lang=js"
import style0 from "./account_page.vue?vue&type=style&index=0&id=78c25f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c25f0a",
  null
  
)

export default component.exports